import React, { useEffect } from 'react';

const ModalAdmin = ({ abierto, onCerrar, titulo, children }) => {
    useEffect(() => {
        if (!abierto) return;
        const cerrarConEscape = e => {
            if (e.key === 'Escape') onCerrar();
        };
        document.addEventListener('keydown', cerrarConEscape);
        return () => document.removeEventListener('keydown', cerrarConEscape);
    }, [abierto, onCerrar]);

    if (!abierto) return null;

    return (
        <div className='modal_admin_fondo' onClick={onCerrar}>
            <div className='modal_admin sombra' role='dialog' aria-modal='true' aria-label={titulo} onClick={e => e.stopPropagation()}>
                <div className='modal_admin_encabezado'>
                    <p className='titulo_1_admin'>{titulo}</p>
                    <button type='button' className='modal_admin_cerrar' onClick={onCerrar} aria-label='Cerrar'>&times;</button>
                </div>
                {children}
            </div>
        </div>
    );
};

export default ModalAdmin;
